var _path, _line, _line2, _line3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeWorkMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.0333H11C12.1046 17.0333 13 16.1379 13 15.0333V4.59863C13 4.09585 12.8106 3.61152 12.4696 3.24207L10.9939 1.64344C10.6153 1.23328 10.0825 1 9.52434 1H2C0.89543 1 0 1.89543 0 3V15.0333C0 16.1379 0.89543 17.0333 2 17.0333Z",
    fill: "#757A88"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.51699,
    y1: 13.65,
    x2: 10.4837,
    y2: 13.65,
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.51699,
    y1: 11.65,
    x2: 10.4837,
    y2: 11.65,
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.68301,
    y1: 9.31699,
    x2: 10.483,
    y2: 9.31699,
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2839 7.40926C2.87503 7.51321 2.50662 7.48697 2.17867 7.33054C1.85023 7.17221 1.63107 6.91658 1.52118 6.56363L2.1288 6.40914C2.20301 6.60591 2.33479 6.74773 2.52415 6.83461C2.7154 6.92101 2.92554 6.93509 3.15458 6.87686C3.41202 6.81141 3.60144 6.67659 3.72284 6.47241C3.84424 6.26823 3.87221 6.03743 3.80676 5.77999C3.74131 5.52256 3.60625 5.33219 3.40159 5.2089C3.19834 5.08323 2.96895 5.05288 2.7134 5.11785C2.53547 5.16309 2.38349 5.24305 2.25747 5.35771C2.13286 5.47001 2.04789 5.60346 2.00256 5.75807L1.42049 5.90606L1.04721 3.53428L3.48622 2.91417L3.62266 3.4508L1.69473 3.94097L1.90096 5.22768L1.91516 5.22407C1.97281 5.07036 2.072 4.93733 2.21271 4.82497C2.35484 4.71024 2.52528 4.62761 2.72403 4.57708C3.11776 4.47697 3.47441 4.52434 3.79399 4.71918C4.11309 4.91212 4.32318 5.20735 4.42424 5.60486C4.53109 6.02508 4.47812 6.40331 4.26535 6.73955C4.05399 7.07341 3.72684 7.29664 3.2839 7.40926ZM6.70636 5.02161L7.03194 6.30216L6.46975 6.4451L6.14417 5.16455L4.95164 5.46775L4.81087 4.91407L6.0034 4.61087L5.68432 3.35588L6.24651 3.21294L6.56559 4.46794L7.75812 4.16474L7.89889 4.71841L6.70636 5.02161Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5332 4.4V1H10.181C10.3205 1 10.4537 1.05832 10.5484 1.16086L12.8673 3.67302C12.9525 3.76538 12.9999 3.88646 12.9999 4.01216V4.9H10.0332C9.75706 4.9 9.5332 4.67614 9.5332 4.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWorkMobile);
export default __webpack_public_path__ + "static/media/home_work-mobile.823aeca3cb8bcee64a4c37839776fd18.svg";
export { ForwardRef as ReactComponent };